module.exports = __webpack_public_path__ + "img/event_2_cover.93746be4.jpg";